import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { Form, Button, Spinner } from 'react-bootstrap';
import notifier from '../../../_utils/notifier';
import { ThreeDots } from '../common/Placeholders.jsx';
import { LoginRequired } from '../../hoc/LoginRequired.jsx';
import { Page } from '../../hoc/Page.jsx';
import TinyContentInfoBlock from '../common/TinyContentInfoBlock.jsx';
import { renderField } from '../common/FormsControls.jsx';

import { getUserData, updateUserData } from '../../actions/user';


const SalesAgree = (props) => {
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    props.getUserData(props.userSlug).then(() => setIsLoading(false));
  }, []);

  const handleSubmit = async (formData) => {
    const response = await props.handleSubmit(formData);
    if (response === undefined){
      notifier.success(gettext('Данные успешно сохранены'));
    }
  }

  if (isLoading) return <ThreeDots/>;
  return(<div>
    <TinyContentInfoBlock name='users_sales_agree' />
    <Form onSubmit={ handleSubmit } className={ '' + (props.anyTouched ? ' was-validate' : '') }>
      <fieldset>
        <legend>{ gettext('Участие в акциях') }:</legend>

        <Field componentLabel={ gettext('Участвовать в акции "Скидка 90%"') }
               component={ renderField }
               element='checkbox'
               name='agree_sale_90'/>

        <Field componentLabel={ gettext('Участвовать в акции "Скидка 60%"') }
               component={ renderField }
               element='checkbox'
               name='agree_sale_60'/>

        <Field componentLabel={ gettext('Участвовать в акции "Скидка 30%-45%"') }
               component={ renderField }
               element='checkbox'
               name='agree_sale_30_45'/>

        <Field componentLabel={ gettext('Участвовать в акции "Купить все аранжировки автора со скидкой 70%"') }
               component={ renderField }
               element='checkbox'
               name='sell_all_once'/>

        <Field componentLabel={ gettext('Участвовать в глобальных распродажах') }
               helptext={ gettext('Ваши аранжировки будут не более 4 раз в год (напр, "Черная пятница" или перед новым годом) участвовать в распродажах со случайными скидками от 35 до 70%. Это позволяет получать значительный дополнительный доход.') }
               component={ renderField }
               element='checkbox'
               name='is_sale'/>
      </fieldset>

      <fieldset>
        <legend>{ gettext('Ценообразование') }:</legend>

        <Field componentLabel={ gettext('Учитывать коэффициенты стран') }
               helptext={ gettext('Выключение данной опции установит единую цену для всех стран.') }
               component={ renderField }
               element='checkbox'
               name='is_country_coefficient'/>
      </fieldset>

      <div className='text-lg-right mt-3'>
        <Button variant="primary" type="submit" disabled={ props.submitting }
                className='mt-2 mt-md-0'>
          { props.submitting
            ? <>
                <Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" className='mr-1'/>
                { gettext('Сохраняется') + '...' }
              </>
            : gettext('Сохранить') }
        </Button>
      </div>
    </Form>
  </div>);
}

SalesAgree.PropTypes = {
  userSlug: PropTypes.string.isRequired,

  initialValues: PropTypes.shape({
    agree_sale_90: PropTypes.bool.isRequired,
    agree_sale_60: PropTypes.bool.isRequired,
    agree_sale_30_45: PropTypes.bool.isRequired,
    sell_all_once: PropTypes.bool.isRequired,
    is_sale: PropTypes.bool.isRequired,
    is_country_coefficient: PropTypes.bool.isRequired,
  }),
  anyTouched: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,

  getUserData: PropTypes.func.isRequired,
  updateUserData: PropTypes.func.isRequired,
}

let mapStateToProps = (state) => {
  return {
    userSlug: state.auth.slug,

    initialValues:{
      agree_sale_90: state.user.agree_sale_90,
      agree_sale_60: state.user.agree_sale_60,
      agree_sale_30_45: state.user.agree_sale_30_45,
      sell_all_once: state.user.sell_all_once,
      is_sale: state.user.is_sale,
      is_country_coefficient: state.user.is_country_coefficient,
    }
  }
};

let mapDispatchToProps = {
  getUserData,
  onSubmit: updateUserData
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  LoginRequired,
  Page,
  reduxForm({
    form:'salesAgreeForm',
    enableReinitialize: true,
  }),
)(SalesAgree);

